<div class="device-messages-popover">
  <div class="device-messages-popover__header">
    {{ 'treatment-page.messages.device-messages.title' | translate }}
  </div>

  @if (messages$ | async; as messages) {
    @if (messages.length === 0) {
      <div class="device-messages-popover__empty">
        {{ 'treatment-page.messages.device-messages.empty' | translate }}
      </div>
    } @else {
      <ion-list class="device-messages-popover__list">
        @for (message of messages; track message.id) {
          <ion-item lines="full" class="device-messages-popover__item">
            <ion-label class="ion-text-wrap">
              <p class="device-messages-popover__text">{{ message.text }}</p>
              <p class="device-messages-popover__time">{{ formatTime(message.timestamp) }}</p>
            </ion-label>
          </ion-item>
        }
      </ion-list>
      <div class="device-messages-popover__footer">
        <ion-button fill="clear" size="small" (click)="clearAll()">
          {{ 'treatment-page.messages.device-messages.clear-all' | translate }}
        </ion-button>
      </div>
    }
  }
</div>
